import React from "react";

// Shared by LaunchModal (total budget) and BudgetDrawer (spend cap) — both warn the
// same way when the CPA doesn't divide evenly into the amount, so some of it can never
// be spent. `noun` names whichever amount is short ("budget" or "cap").
export function ShortfallWarning({ shortfall, noun }) {
  if (shortfall == null) return null;
  return (
    <div style={{ display:"flex", alignItems:"center", gap:6, marginTop:8, fontSize:12, color:"#9A6700" }}>
      <span>⚠</span>
      <span>Won't fully spend — ${shortfall.toLocaleString("en-US", { maximumFractionDigits:2 })} short of {noun} at this CPA</span>
    </div>
  );
}
